var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGermany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagGermany_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagGermany_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagGermany_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagGermany_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagGermany_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-11 17.324h68.556V3.998H-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1001F",
    d: "M-11 30.656h68.556V17.324H-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6D928",
    d: "M-11 43.99h68.556V30.656H-11z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iNm0wdWx2NW9wYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJwejlwaXNzajJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzZtMHVsdjVvcGEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiM2bTB1bHY1b3BhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjcHo5cGlzc2oyYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzAwMCIgZD0iTTAgMTMuMzI0TDY4LjU1NiAxMy4zMjQgNjguNTU2IC0wLjAwMiAwIC0wLjAwMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMSA0KSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNFMTAwMUYiIGQ9Ik0wIDI2LjY1Nkw2OC41NTYgMjYuNjU2IDY4LjU1NiAxMy4zMjQgMCAxMy4zMjR6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEgNCkiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRjZEOTI4IiBkPSJNMCAzOS45OUw2OC41NTYgMzkuOTkgNjguNTU2IDI2LjY1NiAwIDI2LjY1NnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMSA0KSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlagGermany as ReactComponent };